import React from 'react';
import sampleLayouts from '../../configs/config-sample-layouts.json';
import * as dzsHelpers from '../js_common/_helpers';

const {
  SelectControl,
  ServerSideRender,
} = wp.components;


let __ = (arg) => {
  return arg;
};


if (wp.i18n) {
  __ = wp.i18n.__;
}
String.prototype.convertToSlug = function () {
  return this
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')
    ;
}

export default class BlockShop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainOptions_expanded: false,
      mainExamples_expanded: false,
    }
    // console.log('props -   ', props);


    // console.log('dzsHelpers.get_query_arg(window.location.href,\'layout-imported\')- ' ,dzsHelpers.get_query_arg(window.location.href,'layout-imported'));
    if (dzsHelpers.get_query_arg(window.location.href, 'layout-imported')) {

      // console.log('dzsHelpers.get_query_arg(window.location.href,\'layout-imported\') - ', dzsHelpers.get_query_arg(window.location.href,'layout-imported'), props);
      props.mainprops.attributes.layout = String(dzsHelpers.get_query_arg(window.location.href, 'layout-imported', true)).convertToSlug();

    }
    // this.props.mainprops.setAttributes({layout: val})
    this.props = props;
  }


  render() {
    // console.log('this.props - ', this.props, this.props.mainprops.attributes.layout);
    let onClickToggleOptions = (key) => () => {
      this.setState({
        [key]: !this.state[key]
      })
    };

    const selectLayoutOptions = [...this.props.cpt_posts];
    // console.log('sampleLayouts - ', sampleLayouts);

    const styleClearBoth = {
      clear: 'both'
    }

    let sampleLayoutsRender = (
      <div className={"sample-layouts"}>
        {Object.keys(sampleLayouts).map((key) => {
          const sampleLayout = sampleLayouts[key];

          const styleObj = {
            'backgroundImage': 'url(' + window.dzswtl_settings.base_url + 'sampledata/img/' + key + '.jpg'
          }
          return (
            <div className="dzs-col-md-4" key={key}>
              <div className="dzswtl-import-layout add-import-query-arg" data-layout-name={key}>
                <div className="divimage fullwidth  " style={styleObj}/>
                <div className="import-layout--label">
                  {sampleLayout.title}
                </div>
              </div>
            </div>
          );
        })}
        <div style={styleClearBoth}/>
      </div>
    )
    // console.log({sampleLayoutsRender});

    selectLayoutOptions.unshift({label: __('Select'), value: ''});

    return (
      <div className={this.props.mainprops.className}>
        <div className=''>
          <div className="zoomsounds-containers">
            <h6>{__('WooCommerce Shop Layout')}</h6>
            <div className="react-setting-container">
              <div className="react-setting-container--label">{__('Select layout')}</div>
              <div className="react-setting-container--control">

                <SelectControl
                  value={this.props.mainprops.attributes.layout}
                  options={selectLayoutOptions}
                  onChange={(val) => {
                    this.props.mainprops.setAttributes({layout: val})
                  }}
                />
              </div>
            </div>
            {this.props.mainprops.attributes.layout ? (
              <div className={"sidenote"}>{__('Edit playlist from ')}<a className={'ultibox-item-delegated'} data-suggested-width={'1400'} href={this.props.editUrl}>{__('here')}</a></div>
            ) : ''}


            <div className="dzs--gutenberg-preview-block">
              <ServerSideRender
                block={this.props.key_block}
                attributes={this.props.mainprops.attributes}
              />
              <div className={"button-secondary2 preview-block--expander"} onClick={() => {
                const _c = document.querySelector('.dzs--gutenberg-preview-block');
                if (_c.classList.contains('expanded')) {

                  _c.classList.remove('expanded');
                  _c.querySelector('.expander-icon').innerHTML = '&#x2207;';
                } else {

                  _c.classList.add('expanded');
                  _c.querySelector('.expander-icon').innerHTML = '&#x2206;';
                }
              }}><span className="expander-label">{__("گسترش پیش نمایش")}</span> <span
                className="expander-icon">&#x2207;</span></div>
            </div>

            <div className="dzs--gutenberg--extra-options">
              <h5 onClick={onClickToggleOptions('mainOptions_expanded')}
                  className="dzs--gutenberg--extra-options--trigger">{!this.state.mainOptions_expanded ? (
                <span>{__('Other options')}  &darr;</span>) : (<span>{__('Retract')}  &uarr;</span>)}</h5>
              <div className="dzs--gutenberg--extra-options--content">
                {this.state.mainOptions_expanded ? this.props.player_inspector_controls : ''}
              </div>
            </div>

            <div className="dzs--gutenberg--extra-options">
              <h5 onClick={onClickToggleOptions('mainExamples_expanded')}
                  className="dzs--gutenberg--extra-options--trigger">{!this.state.mainExamples_expanded ? (
                <span>{__('Examples')}  &darr;</span>) : (<span>{__('Retract')}  &uarr;</span>)}</h5>
              <div className="dzs--gutenberg--extra-options--content">
                {this.state.mainExamples_expanded ? sampleLayoutsRender : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}